import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { format } from "date-fns";
import { fullDateFullYearFormat, timeFormat } from "@common/helpers/date";
import { memo } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { NestedTaskRow } from "../../types";

export const CreatedAtCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedTaskRow, Date>) => {
        const task = row.original as Task;

        if (row.original.isGroup || row.original.isNewPlaceholder) {
            return null;
        }

        return (
            <ViewTableCell>
                {task.createdAt ? (
                    <Tooltip content={format(task.createdAt, timeFormat)}>
                        <div>
                            {format(task.createdAt, fullDateFullYearFormat)}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                )}
            </ViewTableCell>
        );
    },
);
